/**
 * In-session Compliance Queue overrides (assignment, status).
 * Sample cases stay in complianceQueueSpec. Opening a case does not assign it.
 * Legacy Awaiting Information collapses to In Progress.
 */

const overrides = new Map();

const keyOf = (caseId) => String(caseId || '').trim();

export function getComplianceCaseOverride(caseId) {
  return overrides.get(keyOf(caseId)) || null;
}

export function patchComplianceCaseOverride(caseId, patch) {
  const key = keyOf(caseId);
  if (!key) return null;
  const next = { ...(overrides.get(key) || {}), ...patch };
  overrides.set(key, next);
  return next;
}

const normalizeComplianceQueueStatus = (status) => {
  if (
    status === 'Information Requested' ||
    status === 'Awaiting Information' ||
    status === 'Under Review'
  ) {
    return 'In Progress';
  }
  return status;
};

export function applyComplianceQueueSession(row) {
  if (!row?.compliance_id) return row;
  const patch = getComplianceCaseOverride(row.compliance_id);
  const status = normalizeComplianceQueueStatus(patch?.status || row.case_status);
  const supportTeam =
    patch?.supportTeamMember ||
    patch?.support_team_member ||
    row.support_team_member ||
    row.supportTeamMember;
  if (!patch && status === row.case_status) return row;
  return {
    ...row,
    case_status: status,
    verification_status: status,
    support_team_member: supportTeam,
    supportTeamMember: supportTeam,
    assigned_to: supportTeam,
    last_updated: patch?.lastUpdated || row.last_updated,
  };
}
